import React from 'react';

import { isNumeric } from 'dpl/shared/form/utils';

interface LocationData {
  city_state?: string;
  distance?: number;
}

export function getBuyerLocationDescription({
  location
}: {
  location: LocationData | null | undefined;
}) {
  const { distance, city_state: cityState } = location || {};
  const isNearby =
    isNumeric(distance) && distance != null && distance > 0 && distance < 250;

  return [
    cityState,
    isNearby && `${distance} ${distance === 1 ? 'mile' : 'miles'} away`
  ]
    .filter(Boolean)
    .join(' · ');
}

interface BreederLocationDescriptionProps {
  location: LocationData | null | undefined;
  onDropOffClick?: () => void;
}

export function getBreederLocationDescription({
  location,
  onDropOffClick
}: BreederLocationDescriptionProps): React.ReactNode {
  const { distance, city_state: cityState } = location || {};
  const hasDistance = isNumeric(distance) && distance != null && distance > 0;

  if (hasDistance && distance >= 250 && onDropOffClick) {
    return (
      <span>
        {cityState}
        {cityState && ' · '}
        <button
          type="button"
          className="underline stone-700"
          onClick={onDropOffClick}
        >
          Drop-off closer to you
        </button>
      </span>
    );
  }

  return [
    cityState,
    hasDistance &&
      distance < 250 &&
      `${distance} ${distance === 1 ? 'mile' : 'miles'} away`
  ]
    .filter(Boolean)
    .join(' · ');
}
